// UserChangePasswordDialog - MODULE
// ***********************************************************************************************************************
import * as React from "react";
import * as userService from "../../models/services/userService";
import { Base } from "ui/Scripts/source/framework/base";
import { SaveDataObj } from "../../framework/saveData";
import { Dialog } from "../framework/dialog";
import { AppUtils } from "../../framework/appUtils";
import { ConfirmationDialogResult, DialogButtonType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";

//UserChangePasswordDialog
export interface IUserChangePasswordDialogProp {
    classes?: string;
    minPasswordLength: number;
    rowId: string;
    onOk: (rowId: string) => void;
    onCancel: () => void;
}

export interface IUserChangePasswordDialogState {
    oldPassword: string;
    newPassword: string;
    newPasswordConfirmation: string;
}

export class UserChangePasswordDialog extends React.Component<IUserChangePasswordDialogProp, IUserChangePasswordDialogState> {
    private orgStateHash: string = "";

    constructor(props: IUserChangePasswordDialogProp) {
        super(props);
        this.state = {
            oldPassword: "",
            newPassword: "",
            newPasswordConfirmation: "",
        };
        const saveData = this.getSaveDataFromState(props, this.state);
        this.orgStateHash = saveData.hash;
    }

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "o_p") {
            this.setState({ oldPassword: value });
        } else if (name === "n_p") {
            this.setState({ newPassword: value });
        } else if (name === "n_pc") {
            this.setState({ newPasswordConfirmation: value });
        }
    };

    getSaveDataFromState = (props: IUserChangePasswordDialogProp, state: IUserChangePasswordDialogState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("rowId", props.rowId);
        result.append("oldPassword", state.oldPassword);
        result.append("newPassword", state.newPassword);
        result.append("newPasswordConfirmation", state.newPasswordConfirmation);
        return result;
    };
    
    checkErrors = (): Promise<boolean> => {
        const state = this.state;
        return new Promise<boolean>((resolve) => {
            if (!state.oldPassword) {
                AppUtils.showErrorMessage(Translations.PasswordMustBeDefined);
                return resolve(false);
            }
            if (!state.newPassword) {
                AppUtils.showErrorMessage(Translations.NewPasswordMustBeDefined);
                return resolve(false);
            }
            const errorMessage = Base.isValidPassword(state.newPassword, this.props.minPasswordLength);
            if (errorMessage) {
                AppUtils.showErrorMessage(errorMessage);
                return resolve(false);
            }
            if (!state.newPasswordConfirmation || state.newPassword !== state.newPasswordConfirmation) {
                AppUtils.showErrorMessage(Translations.PasswordConfirmationDoesNotMatchPassword);
                return resolve(false);
            }
            return resolve(true);
        });
    };

    getWarningMessage = (): Promise<string> => {
        return new Promise<string>((resolve) => {
            return resolve("");
        });
    };

    saveToDb = async () => {
        const props = this.props;
        const state = this.state;
        if (!await AppUtils.validate(this.checkErrors, this.getWarningMessage)) return;
        const saveData = this.getSaveDataFromState(props, state);
        //Call server
        const result = await AppUtils.callService(() => userService.changePassword(saveData.obj));
        if (!result) return;
        props.onOk(result.rowId);
    };

    handleSave = () => {
        this.saveToDb();
    };

    handleCancel = async () => {
        const props = this.props;
        const state = this.state;
        const cancelResult = await AppUtils.cancel(this.getSaveDataFromState(props, state).hash, this.orgStateHash);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            this.saveToDb();
        } else {
            props.onCancel();
        }
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Dialog
                classes={"userChangePasswordDialog px300" + (props.classes ? " " + props.classes : "")}
                title={Translations.ChangePassword}
                body={
                    <div className="small-control-labels">
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group required">
                                    <label className="control-label">{Translations.OldPassword}</label>
                                    <input className="form-control" type="password" name="o_p" title={Translations.OldPassword} maxLength={50} readOnly={false} disabled={false} value={state.oldPassword} required={true} onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group required">
                                    <label className="control-label">{Translations.NewPassword}</label>
                                    <input className="form-control" type="password" name="n_p" title={Translations.NewPassword} maxLength={50} readOnly={false} disabled={false} value={state.newPassword} required={true} onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group required">
                                    <label className="control-label">{Translations.ConfirmPassword}</label>
                                    <input className="form-control" type="password" name="n_pc" title={Translations.ConfirmPassword} maxLength={50} readOnly={false} disabled={false} value={state.newPasswordConfirmation} required={true} onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                }
                buttons={[
                    { title: Translations.Save, buttonType: DialogButtonType.Primary, onClick: this.handleSave },
                    { title: Translations.Cancel, buttonType: DialogButtonType.Default, onClick: this.handleCancel }
                ]}
                onClose={this.handleCancel}
            />
        );
    }
}